var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-media-gallery-modal" }, [
    _c("div", {
      staticClass: "c-media-gallery-modal--backdrop",
      on: {
        click: function($event) {
          return _vm.handleModalClose()
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "c-media-gallery-modal--contentwrapper" }, [
      _c(
        "div",
        {
          staticClass: "c-media-gallery-modal--content",
          style: { width: _vm.contentWidth + "px" }
        },
        [
          _c(
            "div",
            {
              ref: "mediaWrapper",
              staticClass: "c-media-gallery-modal--mediawrapper",
              class: { "has-caption": _vm.currentImage.caption },
              style: { height: _vm.contentHeight + "px" }
            },
            [
              _c("div", { staticClass: "c-media-gallery-modal--mainmedia" }, [
                _c(
                  "div",
                  {
                    ref: "transformWrapper",
                    staticClass: "c-media-gallery-modal--transformwrapper",
                    style: {
                      scale: _vm.imageScale,
                      left: this.positionX + "px",
                      top: this.positionY + "px"
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.currentImage.url },
                      on: { load: _vm.handleImageLoad }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-media-gallery-modal--modaltoggle" }, [
                _c(
                  "div",
                  {
                    staticClass: "c-media-gallery-modal--button",
                    on: {
                      click: function($event) {
                        return _vm.handleModalClose()
                      }
                    }
                  },
                  [
                    _c("v-icon", {
                      attrs: { name: "icon-minimize", size: "xs" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-media-gallery-modal--zoomcontrols" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "c-media-gallery-modal--button",
                      on: {
                        click: function($event) {
                          return _vm.handleZoomIn()
                        }
                      }
                    },
                    [
                      _c("v-icon", {
                        attrs: { name: "icon-zoom-in", size: "xs" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "c-media-gallery-modal--button",
                      on: {
                        click: function($event) {
                          return _vm.handleZoomOut()
                        }
                      }
                    },
                    [
                      _c("v-icon", {
                        attrs: { name: "icon-zoom-out", size: "xs" }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "modalFooter",
              staticClass: "c-media-gallery-modal--footer"
            },
            [
              _vm.currentImage.caption
                ? _c("div", { staticClass: "c-media-gallery-modal--caption" }, [
                    _vm._v(_vm._s(_vm.currentImage.caption))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "c-media-gallery-modal--navigation" }, [
                _c(
                  "button",
                  {
                    staticClass: "left",
                    on: { click: _vm.handlePreviousClick }
                  },
                  [
                    _c("v-icon", {
                      attrs: { name: "icon-chevron", size: "xs" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.navigationText))]),
                _vm._v(" "),
                _c(
                  "button",
                  { on: { click: _vm.handleNextClick } },
                  [
                    _c("v-icon", {
                      attrs: { name: "icon-chevron", size: "xs" }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }